import { apiClient } from './api.client';
import type { EducationConfiguration } from '../utils/educationDemo';

export interface CampusCatalog {
  people: { id: number; first_name: string; last_name: string; employee_id: string; is_active: boolean }[];
  locations: { id: number; name: string }[];
  cameras: { id: number; name: string; locationId: number }[];
}
export interface CampusResponse {
  revision: number; canManage: boolean; matchingEnabled: boolean; configuration: EducationConfiguration | null; catalog: CampusCatalog;
}
export interface CampusAction {
  id: string; event_id: number; location_id: number; location_name: string; event_type: string;
  recipient_id: number; recipient_firstname: string; recipient_lastname: string;
  notification_id: string; status: string; triggered_at: string;
  location_timezone?: string;
}
export interface CampusRule { id: string; location_id: number; recipient_id: number; enabled: boolean; }
export interface CampusRecipients { id: number; location_id: number; firstname: string; lastname: string; }
const root = '/camera-security/campus';
export const campusService = {
  getConfiguration: (signal?: AbortSignal) => apiClient.get<CampusResponse>(root + '/configuration', undefined, { signal }),
  saveConfiguration: (revision: number, configuration: EducationConfiguration) => apiClient.put<{ revision: number; configuration: EducationConfiguration }>(root + '/configuration', { revision, configuration }),
  getActions: (locationId?: number, eventId?: number, signal?: AbortSignal) => apiClient.get<{ items: CampusAction[] }>(root + '/actions', { location_id: locationId, event_id: eventId }, { signal }),
  getAlertRules: () => apiClient.get<{ items: CampusRule[]; recipients: CampusRecipients[] }>(root + '/alert-rules'),
  saveAlertRule: (rule: Omit<CampusRule, 'id'>) => apiClient.put<CampusRule>(root + '/alert-rules', rule),
};
